import React from "react";
import { ReviewTranslations } from "../reviewTranslations";
import { T } from "../../../components/T";

export const ReviewsLabel: React.FC<{ reviewsCount: number; t: ReviewTranslations }> = ({ reviewsCount, t }) => (
  <>
    {reviewsCount} {reviewsCount === 1 ? <T>{t("reviewsSingular")}</T> : <T>{t("reviewsPlural")}</T>}
  </>
);
